export default __webpack_public_path__ + "static/media/crossbrowsertesting.ec3c697a.svg";